import Vue from 'vue';
import Vuex from 'vuex';
import { _api } from '../../../utils/apiAxios';
import { getField, updateField } from 'vuex-map-fields';
import groupBy from 'lodash/groupBy';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    bonuses: {},
    bonusStatus: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateBonusStatus(state, row) {
    state.bonusStatus = {
      ...state.bonusStatus,
      ...row,
    };
  },
  BONUSES_UPATE: (state, payload) => {
    state.bonuses = groupBy(payload, 'groups[0].name');
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async tryBonus({ commit }, payload) {
    try {
      commit('updateBonusStatus', {
        loading: true,
        success: false,
        error: false,
      });
      delete _api.defaults.headers.common['epos-token'];
      _api.get(payload.url + '/wp-json/cms-request/v1/get-bonuses/' + payload.lang).then(res => {
        if (res.status === 200) {
          commit('updateBonusStatus', { success: true, error: false });
          commit('BONUSES_UPATE', res.data);
        } else {
          commit('updateBonusStatus', { success: false, error: true });
        }
        commit('updateBonusStatus', { loading: false });
      });
    } catch (err) {
      console.log({ err });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
